import React from 'react';
import { Tabs, Tab, Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { alpha } from '@mui/material/styles';

const StyledTabs = styled(Tabs)(({ theme }) => ({
    minHeight: 40,
    borderBottom: `2px solid ${theme.palette.divider}`,

    '& .MuiTabs-indicator': {
        height: 3,
        backgroundColor: theme.palette.primary.main,
    },
}));

const StyledTab = styled(Tab)(({ theme }) => ({
    minHeight: 40,
    minWidth: 80,
    padding: '8px 16px',
    fontSize: '0.8125rem',
    fontWeight: 500,
    textTransform: 'none',
    color: theme.palette.text.secondary,

    '&.Mui-selected': {
        color: theme.palette.primary.main,
        fontWeight: 600,
    },

    '&:hover': {
        color: theme.palette.primary.main,
        backgroundColor: alpha(theme.palette.primary.main, 0.06),
    },

    '&:focus-visible': {
        outline: `2px solid ${theme.palette.primary.main}`,
        outlineOffset: '-2px',
    },
}));

const LsTabs = ({
                    value,
                    onChange,
                    tabs = [],
                    variant = 'scrollable',
                    ...props
                }) => {
    return (
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <StyledTabs
                value={value}
                onChange={onChange}
                variant={variant}
                scrollButtons="auto"
                {...props}
            >
                {tabs.map((tab, index) => (
                    <StyledTab
                        key={tab.value || index}
                        label={tab.label}
                        icon={tab.icon}
                        iconPosition={tab.iconPosition || 'start'}
                        value={tab.value || index}
                    />
                ))}
            </StyledTabs>
        </Box>
    );
};

export default LsTabs;